<template>
  <div class="callx">

    <!-- ── Filter workspace ── -->
    <div class="callx-filter">
      <div class="callx-filter__head">
        <span class="callx-filter__badge"><i class="fas fa-sliders-h"/></span>
        <span class="callx-filter__title">{{ msg('Filters') }}</span>
        <span class="callx-filter__line"/>
        <button type="button" class="callx-icon-btn" v-b-tooltip.hover :title="msg('Reload')" @click="refresh()">
          <i class="fas fa-redo" :class="{'fa-spin': loading}"/>
        </button>
      </div>

      <div class="callx-grid">
        <!-- Branch -->
        <div class="callx-field">
          <label class="callx-label"><i class="fas fa-code-branch mr-25"/>{{ msg('Branch') }}</label>
          <v-select
              v-model="filter.buid"
              :dir="isRTL ? 'rtl' : 'ltr'"
              :options="allBranches"
              class="callx-select w-100"
              label="name"
              :reduce="(branch) => branch.id"
              :clearable="false"
          />
        </div>

        <!-- Caller -->
        <div class="callx-field">
          <label class="callx-label"><i class="fas fa-phone mr-25"/>{{ msg('caller') }}</label>
          <b-input-group size="sm" class="callx-group">
            <b-input-group-prepend is-text><i class="fas fa-phone"/></b-input-group-prepend>
            <b-form-input v-model="filter.from"/>
          </b-input-group>
        </div>

        <!-- Receiver -->
        <div class="callx-field">
          <label class="callx-label"><i class="fas fa-inbox mr-25"/>{{ msg('receiver') }}</label>
          <b-input-group size="sm" class="callx-group">
            <b-input-group-prepend is-text><i class="fas fa-phone"/></b-input-group-prepend>
            <b-form-input v-model="filter.to"/>
          </b-input-group>
        </div>

        <!-- Status -->
        <div class="callx-field">
          <label class="callx-label"><i class="fas fa-signal mr-25"/>{{ msg('Status') }}</label>
          <v-select
              v-model="filter.status"
              :dir="isRTL ? 'rtl' : 'ltr'"
              :options="callStatus"
              class="callx-select w-100"
              label="text"
              :reduce="(status) => status.value"
          />
        </div>
      </div>
    </div>

    <!-- ── Calls panel ── -->
    <div class="callx-panel">
      <div class="callx-panel__head">
        <span class="callx-panel__badge"><i class="fas fa-phone-volume"/></span>
        <span class="callx-panel__title">{{ msg('Calls') }}</span>
        <b-badge v-if="count > 0" pill variant="light-primary" class="ml-50">{{ count }}</b-badge>
        <span class="callx-panel__line"/>
      </div>

      <!--Table-->
      <calls-table v-bind:filter="filter" ref="calls-table" @busy="loading = $event" @count="count = $event"/>
    </div>

  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import CallsTable from "@/components/tables/CallsTable.vue";

export default {
  name: "calls",
  components: {CallsTable},
  data: () => ({
    loading: false,
    count: 0,
    loadingStats: true,

    filter: {
      from: null,
      to: null,
      status: null,
      buid: null,
      pageUrl: null  // this holds next/previous cursor from API

    },
    stats: {},
  }),
  watch: {
    filter: {
      deep: true,
      handler() {
        this.refresh();
      }
    },
  },
  created() {
    if (this.allBranches.length > 0 && !this.filter.buid) {
      this.filter.buid = this.allBranches[0].id;
    }
  },
  mounted() {
    this.refresh();

  },
  computed: {

    ...mapGetters('reception', ['allStatus']),
    ...mapGetters('data', ['getAllBranches']),
    allBranches() {
      return Object.values(this.getAllBranches)
    },
    callStatus() {
      let $this = this;
      return this.allStatus.map(status => ({
        value: status.value,
        text: $this.msg(status.text)
      }))
    },
  },

  methods: {

    refresh() {
      // guard: the deep watcher can fire before the table is mounted
      if (this.$refs['calls-table'] != null) {
        this.$refs['calls-table'].refresh();
      }
    },
  }
}
</script>


<style lang="scss" scoped>
/* ── filter workspace ── */
.callx-filter {
  background: #fff; border: 1px solid rgba(15, 23, 42, .06); border-radius: 16px;
  padding: 14px 18px; margin-bottom: 14px;
  box-shadow: 0 2px 10px rgba(15, 23, 42, .04);
}
.callx-filter__head { display: flex; align-items: center; gap: 8px; margin-bottom: 12px; }
.callx-filter__badge {
  width: 30px; height: 30px; border-radius: 9px; flex-shrink: 0;
  display: inline-flex; align-items: center; justify-content: center;
  background: rgba(115, 103, 240, .14); color: #7367f0; font-size: .8rem;
}
.callx-filter__title { font-size: .82rem; font-weight: 800; text-transform: uppercase; letter-spacing: .06em; color: #475569; }
.callx-filter__line { flex: 1; height: 1px; background: linear-gradient(90deg, rgba(100, 116, 139, .18), transparent); }
.callx-icon-btn {
  width: 30px; height: 30px; border: none; border-radius: 9px; cursor: pointer;
  display: inline-flex; align-items: center; justify-content: center;
  background: rgba(15, 23, 42, .05); color: #64748b; font-size: .74rem;
  transition: background .15s, color .15s;
  &:hover { background: rgba(115, 103, 240, .14); color: #7367f0; }
  &:focus { outline: none; }
}

/* filter grid */
.callx-grid { display: grid; grid-template-columns: 1.2fr 1fr 1fr 1fr; gap: 12px 14px; align-items: end; }
@media (max-width: 1100px) { .callx-grid { grid-template-columns: 1fr 1fr; } }
@media (max-width: 640px) { .callx-grid { grid-template-columns: 1fr; } }
.callx-field { min-width: 0; }
.callx-label {
  display: flex; align-items: center;
  font-size: .66rem; font-weight: 800; text-transform: uppercase; letter-spacing: .06em;
  color: #94a3b8; margin-bottom: 5px;
  i { opacity: .7; }
}
.callx-field :deep(.form-control) { height: 34px; }
.callx-group :deep(.input-group-text) { height: 34px; background: rgba(15, 23, 42, .03); border-color: rgba(15, 23, 42, .1); color: #94a3b8; font-size: .7rem; }
.callx-field :deep(.vs__dropdown-toggle) { min-height: 34px; border-color: rgba(15, 23, 42, .1); }

/* ── calls panel ── */
.callx-panel {
  background: #fff; border: 1px solid rgba(15, 23, 42, .06); border-radius: 16px;
  padding: 14px 18px 12px;
  box-shadow: 0 2px 10px rgba(15, 23, 42, .04);
}
.callx-panel__head { display: flex; align-items: center; gap: 8px; margin-bottom: 10px; }
.callx-panel__badge {
  width: 30px; height: 30px; border-radius: 9px; flex-shrink: 0;
  display: inline-flex; align-items: center; justify-content: center;
  background: rgba(0, 165, 181, .14); color: #00a5b5; font-size: .8rem;
}
.callx-panel__title { font-size: .82rem; font-weight: 800; text-transform: uppercase; letter-spacing: .06em; color: #475569; }
.callx-panel__line { flex: 1; height: 1px; background: linear-gradient(90deg, rgba(100, 116, 139, .18), transparent); }
</style>

<style lang="scss">
.dark-layout {
  .callx-filter, .callx-panel { background: #283046; border-color: rgba(255, 255, 255, .07); box-shadow: 0 2px 10px rgba(0, 0, 0, .2); }
  .callx-filter__title, .callx-panel__title { color: #d0d2d6; }
  .callx-filter__line, .callx-panel__line { background: linear-gradient(90deg, rgba(255, 255, 255, .12), transparent); }
  .callx-icon-btn { background: rgba(255, 255, 255, .06); color: #94a3b8; }
  .callx-label { color: #8a92a6; }
  .callx-group .input-group-text { background: rgba(255, 255, 255, .04); border-color: rgba(255, 255, 255, .12); color: #8a92a6; }
}
</style>
